import axios from './axiosInstances/axiosInstance';

const URI = '/baskets';

export const getBasketInfo = (basketId) => {
  return axios.get(`${URI}/${basketId}`);
};
